import { z } from "zod";

export const KnowledgeBridgeGrantSchema = z.object({
  id: z.string(),
  name: z.string(),
  access: z.enum(["read", "write"]),
  expiresAt: z.string(),
  lastUsedAt: z.string().nullable(),
});
export type KnowledgeBridgeGrant = z.infer<typeof KnowledgeBridgeGrantSchema>;
export const KnowledgeBridgeCreateSchema = z
  .object({
    name: z.string().trim().min(1).max(80),
    access: z.enum(["read", "write"]).default("read"),
    days: z.number().int().min(1).max(30).default(7),
  })
  .strict();
export type KnowledgeBridgeCreate = z.infer<typeof KnowledgeBridgeCreateSchema>;

// Account administration, secret flows, computer control and cross-space aggregations stay
// outside this space-bound grant. Operation schemas remain owned by the platform catalog.
export const KNOWLEDGE_BRIDGE_OPERATIONS = new Set([
  "workspace.search",
  "workspace.resultGuide",
  "workspace.resultSources",
  "bots.list",
  "bots.get",
  "groups.list",
  "groups.get",
  "threads.get",
  "threads.messages",
  "memory.list",
  "memory.exportMarkdown",
  "scratchpad.list",
  "routines.list",
  "routines.history",
  "missions.list",
  "missions.get",
  "missions.prepare",
  "missions.history",
  "missions.changes",
  "missions.repositorySnapshot",
  "missions.repositoryFile",
  "missions.checkLog",
  "projects.list",
  "boards.list",
  "boards.get",
  "tickets.list",
  "tickets.get",
  "tickets.comments",
  "library.groups",
  "artifacts.list",
  "artifacts.listSpace",
  "artifacts.listVersions",
  "artifacts.getById",
  "threads.send",
  "threads.followUp",
  "threads.stop",
  "memory.update",
  "scratchpad.create",
  "scratchpad.update",
  "missions.checkpoint",
  "missions.capture",
  "missions.collectRepository",
  "missions.collectPreview",
  "missions.create",
  "missions.command",
  "projects.save",
  "tickets.create",
  "tickets.update",
  "tickets.move",
  "tickets.comment",
  "library.saveGroup",
  "library.change",
  "artifacts.create",
  "artifacts.saveVersion",
]);
